import { PreferredCountryEnum } from "../../../utils/types";
import type { RootState } from "../app/store";

/**
 * The consent banner is a Canada-only gate. Egypt restaurants are exempt, so
 * the country alone can grant acceptance without anyone clicking anything.
 */
export const isTermsExemptCountry = (
  preferredCountry: string | undefined | null
): boolean => preferredCountry === PreferredCountryEnum.EG;

/**
 * Derived DURING RENDER rather than read straight out of the toggle slice.
 *
 * The slice value is only turned on by an effect in BackgroundRequests, which
 * `_app` now loads with `dynamic(..., { ssr: false })` (#4166). That effect
 * therefore waits on a separate JS chunk, while the config it depends on is
 * already in the store on the first render (useRestaurantHydration dispatches
 * from the render phase). Consumers reading the raw flag showed the banner to
 * Egypt guests for as long as the chunk took to arrive — seconds on mobile.
 *
 * The country half of that decision is pure state, so deriving it here makes
 * the answer correct on the first paint regardless of when the chunk lands.
 * The cookie half (a Canada guest who already accepted) stays in the effect:
 * cookies are not redux state and reading them in a selector is not pure.
 */
export const selectAcceptedTermsAndConditions = (state: RootState): boolean =>
  state.globalComponentsToggleSlice.acceptedTermsAndConditions ||
  isTermsExemptCountry(state.config.restaurantInfo?.preferredCountry);
